import FieldModel from './FieldModel';
import { ToggleInput } from '../inputs';

class ToggleField extends FieldModel {
  getDefaultState = () => ({
    value: this.default ?? false,
    error: false,
    errorMsg: '',
  });

  fieldComponent = (tempState, state, handle) => {
    const prepHandle = (e) => handle({
      [this.kWord]: {
        value: e.target.checked,
        error: false,
        errorMsg: '',
      },
    });
    return (
      <ToggleInput
        label={this.label}
        state={tempState?.[this.kWord] ?? state[this.kWord] ?? this.getDefaultState()}
        handle={prepHandle}
      />
    );
  }
}

export default ToggleField;
